import React from 'react';

const WalletV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.3333 11.6667C13.3333 12.357 13.893 12.9167 14.5833 12.9167C15.2737 12.9167 15.8333 12.357 15.8333 11.6667C15.8333 10.9764 15.2737 10.4167 14.5833 10.4167C13.893 10.4167 13.3333 10.9764 13.3333 11.6667Z",
      stroke: "white",
      strokeWidth: "1.25"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.75 6.66669C15.8047 6.39743 15.8333 6.11875 15.8333 5.83335C15.8333 3.53217 13.9678 1.66669 11.6667 1.66669C9.3655 1.66669 7.5 3.53217 7.5 5.83335C7.5 6.11875 7.52869 6.39743 7.58335 6.66669",
      stroke: "white",
      strokeWidth: "1.25"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.83332 6.66101H13.3333C15.6903 6.66101 16.8688 6.66101 17.6011 7.3936C18.3333 8.12619 18.3333 9.30523 18.3333 11.6634V13.3309C18.3333 15.6891 18.3333 16.8681 17.6011 17.6007C16.8688 18.3333 15.6903 18.3333 13.3333 18.3333H8.33332C5.19062 18.3333 3.61928 18.3333 2.64296 17.3566C1.66666 16.3797 1.66666 14.8076 1.66666 11.6634V9.99598C1.66666 6.85174 1.66666 5.27963 2.64296 4.30285C3.42887 3.51656 4.60035 3.36322 6.66666 3.33331H8.33332",
      stroke: "white",
      strokeWidth: "1.25",
      strokeLinecap: "round"
    }
  )
);

export { WalletV2 };
//# sourceMappingURL=WalletV2.js.map
